// extracted by mini-css-extract-plugin
export default {"remove-item":"ContextMenuItems_remove-item__CN1hm","menu_item":"ContextMenuItems_menu_item__svRyn"};